module.exports = __webpack_public_path__ + "static/media/dm.2fe95f92.svg";